import { render, staticRenderFns } from "./services_home2.vue?vue&type=template&id=43658a32&scoped=true"
import script from "./services_home2.vue?vue&type=script&lang=js"
export * from "./services_home2.vue?vue&type=script&lang=js"
import style0 from "./services_home2.vue?vue&type=style&index=0&id=43658a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43658a32",
  null
  
)

export default component.exports